import { useEffect, useRef, useState } from "react"
import { message } from "antd"
import { exportStaffOrders } from "~/api/staff"
import { downloadByBlob } from "~/common/media/download"
import { ApiRequestError } from "~/common/request"
import { formatDateTime, isAbortError } from "~/common/utils"

export const useOrderExport = (filters: API.Staff.OrderFilterParams) => {
  const [exporting, setExporting] = useState(false)
  const pending = useRef<AbortController | null>(null)

  useEffect(() => () => pending.current?.abort(), [])

  const exportOrders = async (): Promise<void> => {
    if (pending.current) return

    const controller = new AbortController()
    pending.current = controller
    setExporting(true)

    try {
      const { data } = await exportStaffOrders(filters, controller.signal)
      if (controller.signal.aborted) return
      if (!data) throw new Error("导出失败，接口未返回导出文件")
      if (!data.total) {
        void message.info("当前筛选条件下暂无可导出的订单")
        return
      }
      if (!data.url) throw new Error("导出失败，接口未返回下载链接")

      const mobile = filters.user_mobile || "全部用户"
      const time = formatDateTime(Date.now() / 1000)
        .replace(/[-:]/g, "")
        .replace(" ", "-")
      await downloadByBlob(data.url, `订单明细-${mobile}-${time}.xlsx`)
      if (!controller.signal.aborted) {
        void message.success(`已导出 ${data.total} 条订单`)
      }
    } catch (error) {
      if (controller.signal.aborted || isAbortError(error)) return
      if (!(error instanceof ApiRequestError)) {
        void message.error(
          error instanceof Error ? error.message : "订单导出失败，请稍后重试",
        )
      }
    } finally {
      pending.current = null
      if (!controller.signal.aborted) setExporting(false)
    }
  }

  return { exporting, exportOrders }
}
